import React, { FC, useEffect } from 'react';
import styled from 'styled-components/native';

import appsFlyerSDK from '@webtrader/core/appsflyer';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { checkIsNative } from '@webtrader/core/validators/device';

import Text from '@/components/Text';
import { useDemoCreationRouteParams } from '@/utils/navigation';

import NavigationHeader from '../Header';
import CreationForm from './Form';

const DemoCreationScreen: FC = () => {
  const params = useDemoCreationRouteParams();
  const { publicAuth, accountName, setNeedUpdateFields } = params || {};

  const { t } = useTranslation();

  useEffect(() => {
    appsFlyerSDK.trackDemoSignupPageView();
  }, []);

  return (
    <StyledContainer>
      <StyledScreen>
        <NavigationHeader title={t('Open a Demo Account')} />
      </StyledScreen>
      <StyledScrollView>
        <StyledHeaderDescription>{t('Personal Information')}</StyledHeaderDescription>
        <CreationForm publicAuth={publicAuth} accountName={accountName} setNeedUpdateFields={setNeedUpdateFields} />
      </StyledScrollView>
    </StyledContainer>
  );
};

export default DemoCreationScreen;

const StyledScrollView = styled.ScrollView`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background[1]};
  margin-top: ${dynamicSize.convertSize(8)}px;
`;

const StyledContainer = styled.View`
  flex: 1;
`;

const StyledScreen = styled.View`
  padding-start: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-end: ${({ theme }) => theme.sizes.mobile.basePaddingEnd}px;
`;

const StyledHeaderDescription = styled(Text)`
  text-align: ${() => (checkIsNative() ? 'left' : 'start')};
  padding: ${dynamicSize.convertSize(12)}px ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;

  color: ${({ theme }) => theme.colors.text[1]};
  font-size: ${dynamicSize.convertSize(15)}px;
  background-color: ${({ theme }) => theme.colors.background[1]};
`;
